import { DbsSpinnerService } from '@core/services/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MultipleSpinnerService {
  private countLoading = 0;
  private isFirstTimeAccess = true;
  constructor(private dbsSpinnerService: DbsSpinnerService) { }

  show() {
    this.countLoading++;
    this.dbsSpinnerService.isFirstTime = this.isFirstTimeAccess;
    this.dbsSpinnerService.show();
    this.isFirstTimeAccess = false;
  }

  hide() {
    this.countLoading--;
    if (this.countLoading === 0) {
      this.dbsSpinnerService.hide();
    } else if (this.countLoading < 0) {
      throw new Error('countLoading cannot be less than 0');
    }
  }
}
